<app-dashboard-viewer #dashboardViewer [pageTitle]="'Workspace'" [pageHelpLink]="helpLink">
    <div class="home-content-block">
        <p class="content-block">
            You can create your own Workspace using the Manage Workspaces icon. You can add as many Workspaces as you
            need with unique names.
        </p>
    </div>
</app-dashboard-viewer>
